export const UdtErrorCode = {
    VcSchemaAnnotationMissing: 'T001',
    UnexpectedTypeInSerialization: 'T002',
    UnsupportedTypeInUDT: 'T003',
    IncompatibleUDT: 'T004',
    VcSchemaMissingSlug: 'T005',
    VcSchemaDifferentOwner: 'T006',
} as const;
export type UdtErrorCode = (typeof UdtErrorCode)[keyof typeof UdtErrorCode];

export class UdtError extends Error {
    constructor(
        public code: UdtErrorCode,
        msg: string,
    ) {
        super(
            `${msg}\nFor more information about this error, check https://docs.truvity.com/sdk/reference/error-codes#${code}`,
        );
    }
}
